import { Container, Grid } from "@mui/material";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import TopBar from "../../../components/TopBar/TopBar";
import Certificates from "./Certificates";
import DiagnosticTemplate from "./DiagnosticTemplate";
import Forms from "./Forms";
import ReminderTemplate from "./ReminderTemplate";
import TreatmentBundle from "./TreatmentBundle";
import TreatmentPlan from "./TreatmentPlan";
import VitalMaster from "./VitalMaster/VitalMaster";

export const PLAN_TAB_PATHS = {
  TreatmentBundle: "treatment-bundle",
  Forms: "forms",
  TreatmentPlan: "treatment-plan",
  Vitals: "vitals",
  DiagnosticTemplate: "diagnostic-template",
  ReminderTemplate: "reminder-template",
  Certificates: "certificates",
};

export const PLAN_PATH_TO_TAB = {
  "treatment-bundle": "TreatmentBundle",
  forms: "Forms",
  "treatment-plan": "TreatmentPlan",
  vitals: "Vitals",
  "diagnostic-template": "DiagnosticTemplate",
  "reminder-template": "ReminderTemplate",
  certificates: "Certificates",
};

export const PlanRedirect = () => {
  const location = useLocation();
  const tabFromState = location.state?.selectedTab ?? location.state?.activeTab;
  const path = PLAN_TAB_PATHS[tabFromState] ?? PLAN_TAB_PATHS.Forms;
  return <Navigate to={`/plan/${path}`} replace state={location.state} />;
};

const Plan = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { tab } = useParams();
  const selectedTab = PLAN_PATH_TO_TAB[tab];

  const handleSelectedTab = (nextTab) => {
    if (!nextTab || nextTab === selectedTab) return;
    const path = PLAN_TAB_PATHS[nextTab] ?? PLAN_TAB_PATHS.Forms;
    navigate(`/plan/${path}`, { state: location.state });
  };

  if (!selectedTab) {
    return (
      <Navigate
        to={`/plan/${PLAN_TAB_PATHS.Forms}`}
        replace
        state={location.state}
      />
    );
  }

  return (
    <>
      <TopBar>
        <Container maxWidth="xl">
          <Grid container spacing={0}>
            <div className="flex-row">
              {/* <div
                className="ph10pv3"
                onClick={() => {
                  handleSelectedTab("TreatmentBundle");
                }}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "TreatmentBundle"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Treatment Bundle
                </div>
              </div> */}
              <div
                className="ph10pv3"
                onClick={() => {
                  handleSelectedTab("Forms");
                }}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "Forms"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Consent Forms
                </div>
              </div>
              <div
                className="ph10pv3"
                onClick={() => handleSelectedTab("TreatmentPlan")}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "TreatmentPlan"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Protocol Forms
                </div>
              </div>
              <div
                className="ph10pv3"
                onClick={() => handleSelectedTab("Vitals")}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "Vitals"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Parameters
                </div>
              </div>
              <div
                className="ph10pv3"
                onClick={() => handleSelectedTab("DiagnosticTemplate")}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "DiagnosticTemplate"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Diagnostic Template
                </div>
              </div>
              <div
                className="ph10pv3"
                onClick={() => handleSelectedTab("ReminderTemplate")}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "ReminderTemplate"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Reminder Template
                </div>
              </div>
              <div
                className="ph10pv3"
                onClick={() => handleSelectedTab("Certificates")}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "Certificates"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Certificates
                </div>
              </div>
            </div>
          </Grid>
        </Container>
      </TopBar>
      <div className="left-con-white-wh mt10">
        {selectedTab === "TreatmentBundle" ? <TreatmentBundle /> : null}
        {selectedTab === "TreatmentPlan" ? <TreatmentPlan /> : null}
        {selectedTab === "Forms" ? <Forms /> : null}
        {selectedTab === "Vitals" ? <VitalMaster /> : null}
        {selectedTab === "DiagnosticTemplate" ? <DiagnosticTemplate /> : null}
        {selectedTab === "ReminderTemplate" ? <ReminderTemplate /> : null}
        {selectedTab === "Certificates" ? <Certificates /> : null}
      </div>
    </>
  );
};

export default Plan;
